/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiAssistanceRequestDestinationType {
    Destination = 'DESTINATION',
    ClientLocation = 'CLIENT_LOCATION'
}

export function ApiAssistanceRequestDestinationTypeFromJSON(json: any): ApiAssistanceRequestDestinationType {
    return ApiAssistanceRequestDestinationTypeFromJSONTyped(json, false);
}

export function ApiAssistanceRequestDestinationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssistanceRequestDestinationType {
    return json as ApiAssistanceRequestDestinationType;
}

export function ApiAssistanceRequestDestinationTypeToJSON(value?: ApiAssistanceRequestDestinationType | null): any {
    return value as any;
}

